module.exports = __webpack_public_path__ + "static/media/maj-contour-icon.2d617f21.svg";